import Amplitude from "amplitude-js";

const amplitudeClient = Amplitude.getInstance();

let clientId: string = null;
let planName: string = null;

let useAnalyticsAPI = false;

/* Only initialize analytics when a real key is configured
   @ts-ignore need to do this because we comment out the key in config */
if (site["analyticsAPIKey"]) {
  useAnalyticsAPI = true;
  // @ts-ignore
  amplitudeClient.init(site["analyticsAPIKey"]);
}

export const setAnalyticsEligibilityInfo = (id: string, name: string): void => {
  if (useAnalyticsAPI) {
    clientId = id;
    planName = name;
  }
};

export const logEvent = (eventName: string, params?: object): void => {
  if (useAnalyticsAPI) {
    amplitudeClient.setUserProperties({ client_id: clientId, plan_name: planName });
    amplitudeClient.logEvent(eventName, {
      ...params,
      clientID: clientId,
    });
  }
};

export const ANALYTIC_EVENTS = {
  AUTH: {
    accountSettingsButtonClick: "account settings button clicked",
    loginButtonClick: "login button clicked",
    loginInit: "login initiated",
    loginOTP: "login otp submitted",
    loginClear: "login clear submitted",
    loginSuccess: "login successful",
    logoutButtonClick: "logout button clicked",
    logoutSuccess: "logout successful",
  },
  MEDICAL: {
    memberSearch: "member search clicked",
    memberFound: "member search successful",
    benefitSearch: "member benefit search clicked",
    benefitFound: "member benefit search successful",
    claimSearch: "claim search clicked",
  },
  PA_CASE: {
    upload: "pa case document uploaded",
    exit: "pa case exit clicked",
  },
  PA_CASE_CREATE: {
    new: "pa case create new clicked",
    back: "pa case create back clicked",
    submit: "pa case create submit clicked",
    validate: "pa case create test claim submitted",
  },
  PA_CASE_RENEW: {
    new: "pa case renew clicked",
    back: "pa case renew back clicked",
    submit: "pa case renew submit clicked",
    validate: "pa case renew submitted",
  },
  PA_CASE_SEARCH: {
    search: "pa case search clicked",
    found: "pa case search successful",
  },
  PROVIDER_MANAGEMENT: {
    create: "provider management create submitted",
    create_success: "provider management create successful",
    update: "provider management update submitted",
    update_success: "provider management update successful",
    submit: "provider management submit clicked",
    submit_success: "provider management submit successful",
    documentsButtonClicked: "provider documents button clicked",
  },
  ERRORS: {
    caseCreate: "pa case create fail",
    caseCreateMemberNotFound: "pa case create member not found",
    caseCreateInvalidNdc: "pa case create invalid ndc",
    caseCreateInvalidProvider: "pa case create invalid provider",
    caseCreateDrugNotCovered: "pa case create drug not covered",
    caseCreateInvalidQuestionnaire: "pa case create invalid questionnaire",
    caseCreateDuplicateCase: "pa case create duplicate case",
    caseCreatePaToolNotMigrated: "pa case create pa tool not migrated",
    caseCreateEpaConfigMissing: "pa case create epa config missing",
    caseCreateInvalidIcd10: "pa case create invalid icd10",
    renewCodeNotFound: "pa case renew code not found",
    caseNotFound: "pa case search not found",
    caseValidate: "pa case create test claim fail",
    documentUpload: "pa case document upload fail",
    loginFailure: "login failure",
    logoutFailure: "logout failure",
    providerManagementGet: "provider management get fail",
    providerManagementCreate: "provider management create fail",
    providerManagementUpdate: "provider management update fail",
    providerManagementSubmit: "provider management submit fail",
    memberNotFound: "member search fail",
    benefitNotFound: "member benefit search fail",
    claimsNotFound: "claim search fail",
  },
};
